import { StickerContainer } from 'dashboard/components/WorkflowStatusSticker/WorkflowStatusSticker';
import Sticker from 'design-system/components/Sticker';

interface HttpMethodStickerProps {
  method: string;
}

const GetVariant = (method: string) => {
  switch (method) {
    case 'GET':
      return 'green';
    case 'POST':
      return 'blue';
    case 'PATCH':
      return 'yellow';
    case 'DELETE':
      return 'red';
    default:
      return 'basic';
  }
};
const HttpMethodSticker = ({ method }: HttpMethodStickerProps) => {
  const variant = GetVariant(method);
  return (
    <StickerContainer>
      <Sticker variant={variant}>{method}</Sticker>
    </StickerContainer>
  );
};

export default HttpMethodSticker;
